import { entityReducer } from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'

import {
  AGENCY_JOBS_HISTORY_FETCH_BEGIN,
  AGENCY_JOBS_HISTORY_FETCH_FAILED,
  AGENCY_JOBS_HISTORY_FETCH_SUCCEEDED,
} from './action-types'
import type { AgencyJobHistoryEntry } from './types'

export const reducer = entityReducer<AgencyJobHistoryEntry>(
  'agencyJobsHistory',
  {
    [entityTypes.ENTITIES_FETCH_BEGIN]: AGENCY_JOBS_HISTORY_FETCH_BEGIN,
    [entityTypes.ENTITIES_FETCH_SUCCEEDED]: AGENCY_JOBS_HISTORY_FETCH_SUCCEEDED,
    [entityTypes.ENTITIES_FETCH_FAILED]: AGENCY_JOBS_HISTORY_FETCH_FAILED,
  },
  // shift_id filters each agency job's plan lines, so the same agency_job_id has a different payload per query.
  { idKey: 'agency_job_id', localEntityMap: true },
)
